<div [class.dark-theme]="themeService.isDark()">
    <app-header-style-one/>
    <router-outlet/>

    <div
        [ngClass]="{'d-none': router.url === '/login' || router.url === '/register' || router.url === '/coming-soon'}"
    >
        <app-footer></app-footer>
    </div>

    <!--    <app-theme-customizer/>-->
    <!--    <app-snackbar></app-snackbar>-->

    <app-login-modal *ngIf="showLoginModal()"/>

    <app-consent-banner></app-consent-banner>
</div>
